import React, { useState } from "react";
import { useLanguage } from "../context/LanguageContext";

const LanguageSelector = () => {
  const { lang, changeLang } = useLanguage();
  const [open, setOpen] = useState(false);
  
  const languages = [
    { code: "en", name: "English" },
    { code: "hi", name: "हिंदी" },
    { code: "ur", name: "اردو" }
  ];
  
  return (
    <div className="relative">
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center gap-1 px-3 py-1.5 bg-secondary rounded-full text-sm"
        data-testid="language-selector-btn"
      >
        🌐 {languages.find(l => l.code === lang)?.name}
      </button>
      {open && (
        <div className="absolute right-0 top-full mt-1 bg-card border border-border rounded-lg shadow-xl z-50">
          {languages.map(l => (
            <button
              key={l.code}
              onClick={() => { changeLang(l.code); setOpen(false); }}
              className={`block w-full text-left px-4 py-2 hover:bg-secondary ${lang === l.code ? "text-primary" : ""}`}
              data-testid={`lang-${l.code}`}
            >
              {l.name}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;
